module.exports = __webpack_public_path__ + "85dcde6672741e8900e7b12ea4e7a4eb.woff2";